<script>
import { CdrText, CdrLink, CdrGrid } from '@rei/cedar';

export default {
  name: 'AdditionalSavings',
  components: {
    CdrText,
    CdrLink,
    CdrGrid,
  },
  props: {
    heading: { type: String, default: null },
    links: { type: Array, default: () => [] },
  },
};
</script>
<template>
  <div class="additional-savings">
    <cdr-text
      class="additional-savings__heading"
      tag="h2"
    >
      {{ heading }}
    </cdr-text>
    <cdr-grid class="additional-savings__grid">
      <cdr-link
        v-for="(link, index) in links"
        :key="`link-${index}`"
        :href="link.target"
        modifier="standalone"
        class="additional-savings__link"
      >
        {{ link.text }}
      </cdr-link>
    </cdr-grid>
  </div>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
.additional-savings {
  &__heading {
    @include cdr-text-heading-serif-600;
    padding: $cdr-space-three-quarter-x 0;
    margin-bottom: $cdr-space-one-x;
    text-align: center;
  }

  &__grid {
    grid-template-columns: repeat(2, 1fr);

    @include cdr-sm-mq-up {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__link {
    @include cdr-text-utility-sans-strong-400;
    color: $cdr-color-text-primary;
    font-weight: 600;
    text-align: center;
    display: block;
    width: 100%;
    &,
    &:visited,
    &:hover,
    &:active {
      color: $cdr-color-text-primary;
    }
  }
}
</style>
